import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { RemindMeButton } from '../MainPanelHeader/MainPanelHeader';

import css from './NoSearchResultsMaybe.module.css';

const NoSearchResultsMaybe = props => {
  const { listingsAreLoaded, totalItems, remindMeAction } = props;
  const hasNoResult = listingsAreLoaded && totalItems === 0;

  return hasNoResult ? (
    <div className={css.noSearchResults}>
      <p className={css.noResultsMessage}>
        <FormattedMessage id="SearchPage.noResults" />
      </p>

      {remindMeAction ? (
        <div className={css.remindActionContainer}>
          <RemindMeButton remindMeAction={remindMeAction} source="noResults" />
        </div>
      ) : null}

    </div>
  ) : null;
};

export default NoSearchResultsMaybe;
